import { AppContextType } from 'context/AppContext';
import { FluidGatsbyImageFieldType, PrismicTitleFieldType, SliceContext } from '../types';

export enum Versions {
    original = 'original',
    mastered = 'mastered',
}

export type ABPlayersSources = { [key in Versions]: string };

export type ABPlayersHowls = {
    [Versions.original]: Howl;
    [Versions.mastered]: Howl;
};

export type MasteringDemosState = {
    selectedStyle: number;
    selectedVersion: Versions;
    isPlaying: boolean;
};

export type Item = {
    mastering_demos_original: {
        url: string;
    };
    mastering_demos_mastered: {
        url: string;
    };
    mastering_demos_image: FluidGatsbyImageFieldType;
    mastering_demos_style: PrismicTitleFieldType;
    mastering_demos_track_title: PrismicTitleFieldType;
};
export type MasteringDemosProps = {
    slice: {
        __typename: string;
        slice_type: string;
        primary: {
            mastering_demos_original_button_copy: string;
            mastering_demos_mastered_button_copy: string;
            mastering_demos_title: PrismicTitleFieldType;
        };
        items: Item[];
    };
    context: AppContextType;
    sliceContext: SliceContext;
};
